var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('div',[_c('label',[_vm._v("File Preview")]),_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"565px","frameborder":"0"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }